import { TranslationService } from '@alfresco/adf-core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Component, OnInit, Inject} from '@angular/core';

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './projetosinfo.component.html',
  styleUrls: ['./projetosinfo.component.scss']
})
export class ProjetosInfoComponent implements OnInit {

  name: String = '';
  ativo: String = '';
  id: String = '';
  titulo: String = '';
  codGuarda : String = '';
  idCliente : String = '';

  transmiteDocSei : String = '';
  transmiteDocRDC : String = '';

  isProjeto : String = '';
  cancelButtonText = 'Fechar';
  from;
  showTable = false;
  aspect;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
              private dialogRef: MatDialogRef<ProjetosInfoComponent>) {
  }

  ngOnInit() {
    this.name = this.data.name;
    this.ativo = this.data.ativo ? 'Ativo' : 'Inativo';
    this.id = this.data.id;
    this.titulo =  this.data.title;
    this.codGuarda = this.data.codigoGuarda;
    this.isProjeto = this.data.isProjeto ? 'Sim' : 'Não';
    this.transmiteDocRDC = this.data.transmiteDocumentoRDCArq;
    this.transmiteDocSei = this.data.transmiteDocumentoSei;
    this.idCliente = this.data.idCliente;
  }

  onConfirmClick(): void {
    this.dialogRef.close({apagar: true});
  }
  close(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/dialog/projetosinfo/projetosinfo.component.ts